import * as api from '../api';
import { pagingDataUtilities } from '../common';

export const fetchIntakeFormsActions = api.fetchActions('intake-forms', 'fetch-intake-forms');
export const pagingActions = pagingDataUtilities.pagingActions('intake-forms', 'paging');
export const fetchFormPreviewActions = api.fetchActions('intake-forms', 'fetch-form-preview');

export const actionTypes = {
  ...fetchIntakeFormsActions.actionTypes,
  ...pagingActions.actionTypes,
  ...fetchFormPreviewActions.actionTypes,
  SHOW_SELECT_SITE_MODAL : 'intake-forms.show-select-site-modal',
  CLOSE_SELECT_SITE_MODAL : 'intake-forms.close-select-site-modal',
  SET_SELECTED_SITE : 'intake-forms.set-selected-site',
  SET_SELECTED_PROGRAM : 'intake-forms.set-selected-program',
  CONFIRM_SELECTION : 'intake-forms.confirm-selection',
  SET_FILTER_SITE : 'intake-forms.set-filter-site',
};

/**
 * Fetch a single intake form (that had already been created) to preview
 * Executes only if the form does not exist in the store already
 * @param {string} formId guid identifying the intake form
 */
export const getFormPreview = (formId) => api.shouldExecute(['intake', 'formPreviews', formId],
  api.getThunk(`/intake/preview/${formId}`, {}, fetchFormPreviewActions, {formId}));

export function fetchIntakeForms() {
  return (dispatch, getState) => {
    const state = getState();
    const { intake } = state;
    const { pagingData, filterSite } = intake;
    const { currentPage, itemsPerPage, sortBy, sortAsc } = pagingData || {};
    const params = {
      page: currentPage,
      perPage: itemsPerPage,
      sortBy,
      sortAsc,
      filterSite,
    };
    return dispatch(api.shouldExecute(['intake', 'intakeForms'],
      api.getThunk(`/intake`, params, fetchIntakeFormsActions)));
  }
}

export function showSelectSiteModalVisible() {
  return {
    type : actionTypes.SHOW_SELECT_SITE_MODAL,
  }
}

export function closeSelectSiteModalVisible() {
  return {
    type : actionTypes.CLOSE_SELECT_SITE_MODAL,
  }
}

export function setSelectedSite(siteId) {
  return {
    type : actionTypes.SET_SELECTED_SITE,
    siteId
  }
}

export function setSelectedProgram(programId) {
  return {
    type : actionTypes.SET_SELECTED_PROGRAM,
    programId
  }
}

export function confirmSelection() {
  return {
    type : actionTypes.CONFIRM_SELECTION
  }
}

export function setFilterSite(siteId) {
  return {
    type : actionTypes.SET_FILTER_SITE,
    siteId
  }
}

export const changePageNumber = (page) => pagingDataUtilities.changePage(page, pagingActions);
export const changeSort = (newSort) => pagingDataUtilities.changeSort(newSort, pagingActions, ['intake', 'pagingData']);
export const changeResultsPerPage = (perPage) => pagingDataUtilities.changePerPage(perPage, pagingActions, ['intake', 'pagingData']);
